export default __webpack_public_path__ + "static/media/down-arrow.7ee16ca5.svg";